class CollectionGrid {
  constructor(section) {
    this.section = section;
    this.productCards = this.section.querySelectorAll('.collection-product-card');
    this.emptyMessage = this.section.querySelector('.section-collection-grid__empty');

    this.init();
  }

  init() {
    this.initFiltering();
  }

  initFiltering() {
    // Listen to the collection filter event from collection-header
    document.addEventListener('collectionFilter', (event) => {
      const { tag, isDefault } = event.detail;
      this.filterProducts(tag, isDefault);
    });
  }

  filterProducts(filterTag, isDefault) {
    let visibleCount = 0;

    this.productCards.forEach((card) => {
      const filterTags = card.dataset.filterTags || '';

      if (isDefault) {
        // Show all products
        card.classList.remove('is-hidden');
        visibleCount++;
      } else {
        // Show only products with the matching filter tag from metafield
        if (filterTags.includes(filterTag)) {
          card.classList.remove('is-hidden');
          visibleCount++;
        } else {
          card.classList.add('is-hidden');
        }
      }
    });

    // Show/hide empty message
    if (this.emptyMessage) {
      if (visibleCount === 0) {
        this.emptyMessage.classList.remove('is-hidden');
      } else {
        this.emptyMessage.classList.add('is-hidden');
      }
    }
  }
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCollectionGrid);
} else {
  initCollectionGrid();
}

function initCollectionGrid() {
  const sections = document.querySelectorAll('[data-section-type="w-collection-grid"]');
  sections.forEach((section) => {
    new CollectionGrid(section);
  });
}

// Shopify section events
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-section-type="w-collection-grid"]');
    if (section) {
      new CollectionGrid(section);
    }
  });
}
